import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const apiSlice = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://asfak-json-server.herokuapp.com",
    }),
    tagTypes: ["Todos",'Todo'],
    endpoints: (builder) => ({
        getTodos: builder.query({
            query: ({ colors, status }) => {
                const color_likes = colors.map((color) => `color_like=${color}`);
                const queryString = `/todos?${colors.length>0 ?color_likes.join("&"):''}${status!=='' ?`&completed_like=${status}`:'' }`;
                return queryString;
                
            },
            providesTags: ['Todos','Todo'],
        }),
        taskLeft: builder.query({
            query: () => {
                const queryString = `/todos?completed_like=false`;
                return queryString;
            },
            providesTags: ['Todos','Todo'],
        }),
        getTodo: builder.query({
            query: (todoId) => `/todos/${todoId}`,
        }),
        addTodo: builder.mutation({
            query: (data) => ({
                url: "/todos",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Todos"],
        }),
        editTodo: builder.mutation({
            query: ({ id, data }) => (
            {
                url: `/todos/${id}`,
                method: "PATCH",
                body: {[data.type]:data.value},
            }),
            invalidatesTags: [
                "Todos",
                "Todo"
            ],
        }),
        deleteTodo: builder.mutation({
            query: (id) => ({
                url: `/todos/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Todos"],
        }),
    }),
});

export const {
    useGetTodosQuery,
    useGetTodoQuery,
    useTaskLeftQuery,
    useAddTodoMutation,
    useEditTodoMutation,
    useDeleteTodoMutation,
} = apiSlice;
